// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._10vVLP5ZzHsY5uCvLP1X0O{margin:0 -24px 1rem;font-size:.75rem;padding:.5rem 1rem;text-align:center;background-color:#eeeeef;color:#a0a0a0}@media(min-width: 576px){._10vVLP5ZzHsY5uCvLP1X0O{margin:0 -170px 1rem}}._10vVLP5ZzHsY5uCvLP1X0O a{color:#a0a0a0;text-decoration:underline}", ""]);
// Exports
exports.locals = {
	"terms": "_10vVLP5ZzHsY5uCvLP1X0O"
};
module.exports = exports;
